import { BookingListParams, IBookingRepository, IBookingUpdate } from '@common/interfaces';
import AxiosRepository from './axios.repository';

class BookingRepository extends AxiosRepository implements IBookingRepository {
  private static buildParams(params?: BookingListParams) {
    const searchParams = new URLSearchParams();

    if (params?.agencyId) searchParams.append('agency', params.agencyId);
    if (params?.ids) searchParams.append('id__in', params.ids);
    if (params?.limit) searchParams.append('limit', String(params.limit));
    if (params?.offset) searchParams.append('offset', String(params.offset));
    if (params?.ordering) searchParams.append('ordering', params.ordering);
    if (params?.passengerAgency) searchParams.append('passenger_agency', params.passengerAgency);
    if (params?.rangeEnd) searchParams.append('range_end', params.rangeEnd);
    if (params?.rangeStart) searchParams.append('range_start', params.rangeStart);
    if (params?.search) searchParams.append('search', params.search);

    return searchParams;
  }

  async getBookingDetails(facilityId: string, bookingId: string) {
    const { data } = await this.get(`/facilities/${facilityId}/bookings/${bookingId}/`);

    return data;
  }

  async getBookings(facilityId: string, params?: BookingListParams) {
    const searchParams = BookingRepository.buildParams(params);
    const { data } = await this.get(
      `/facilities/${facilityId}/bookings/${params?.show}/?${searchParams}`,
    );
    return data;
  }

  async getFilters(facilityId: string, params?: BookingListParams) {
    const searchParams = BookingRepository.buildParams(params);

    const { data } = await this.get(`/facilities/${facilityId}/bookings/filters/?${searchParams}`);
    return data;
  }

  async exportBookings(facilityId: string, params?: BookingListParams) {
    const searchParams = BookingRepository.buildParams(params);

    const { data } = await this.get(`/facilities/${facilityId}/bookings/export/?${searchParams}`, {
      responseType: 'blob',
    });

    return new File([data], 'booking_list.csv');
  }

  async forwardBooking(facilityId: string, agencyId: string, bookingId: string) {
    const { data } = await this.post(
      `/facilities/${facilityId}/bookings/${bookingId}/forward/${agencyId}/`,
      {},
    );
    return data;
  }

  async updateBooking(facilityId: string, bookingId: string, updateData: IBookingUpdate) {
    const { data } = await this.patch(
      `/facilities/${facilityId}/bookings/${bookingId}/`,
      updateData,
    );
    return data;
  }
}

export default BookingRepository;
